import { useEffect, useState } from 'react'

// ----------------------------------------------------------------------

export default function useSessionStorage<ValueType>(
  key: string,
  defaultValue: ValueType
) {
  const [value, setValue] = useState(() => {
    const storedValue =
      typeof window !== 'undefined' ? sessionStorage.getItem(key) : null
    return storedValue === null ? defaultValue : JSON.parse(storedValue)
  })

  useEffect(() => {
    const listener = (e: StorageEvent) => {
      if (
        typeof window !== 'undefined' &&
        e.storageArea === sessionStorage &&
        e.key === key
      ) {
        setValue(e.newValue ? JSON.parse(e.newValue) : e.newValue)
      }
    }
    window.addEventListener('storage', listener)

    return () => {
      window.removeEventListener('storage', listener)
    }
  }, [key, defaultValue])

  const setValueInSessionStorage = (newValue: ValueType) => {
    setValue((currentValue: any) => {
      const result =
        typeof newValue === 'function' ? newValue(currentValue) : newValue
      if (typeof window !== 'undefined')
        sessionStorage.setItem(key, JSON.stringify(result))
      return result
    })
  }

  return [value, setValueInSessionStorage]
}
